import { useState, useEffect } from "react"
import { auth, fireStore, firebaseTimestamp } from "./firebase"
import { useStore } from "../context/context"
import moment from "moment"

export function useAuth() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(authRes => {
      if(authRes) {
        try {
          const unsub = fireStore.collection("users").onSnapshot(snap => {
            const users = snap.docs.map(doc => doc.data())
            setUser(users.find(user => user.uid == authRes.uid))
            setLoading(false)
          })
          return () => unsub()
        } catch(err) {
          setError(err)
        }
      } else {
        setUser(null)
        setLoading(false)
      }
    })
    
    return () => unsub()
  }, [])

  return [user, loading, error]
}

export function useAuthActions(creds) {
  const { dispatch } = useStore()

  const logout = async () => {
    try {
      await auth.signOut()
      dispatch(
        { type: "SET_NOTIFICATION", payload: { title: "Vous avez été déconnecté", type: "info" } }
      )
    } catch(error) {
      return new Promise((_, reject) => reject(error))
    }
  }

  if(creds) {
    const { email, password, displayName } = creds
    
    const login = async () => {
      try {
        await auth.signInWithEmailAndPassword(email, password)
        dispatch({ type: "SET_NOTIFICATION", payload: "Vous êtes maintenant connecté" })
      } catch(error) {
        return new Promise((_, reject) => reject(error))
      }
    }
  
    const register = async () => {
      try {
        const response = await auth.createUserWithEmailAndPassword(email, password)
  
        const newUser = {
          displayName: displayName,
          email: email,
          uid: response.user.uid,
          posts: [],
          subscriptionType: "free"
        }
  
        fireStore.collection("users").doc(response.user.uid).set(newUser)
          .then(() => {
            console.log("user has been successfully added to db")
            dispatch({ type: "SET_NOTIFICATION", payload: "Votre inscription à été validée" })
          })
          .catch(err => console.log("Error when registering user in db : ", err))
      } catch (error) {
        console.error({error})
        return new Promise((_, reject) => reject(error))
      }
    }

    return { login, register, logout }
  } else {
    return { logout }
  }
}
